/**
 * One cool, clinical family of chip tones — enough variation to keep icon rows
 * from reading as a single monotone block, without turning into a rainbow.
 * Each tint is deep enough to separate from the cream cards, each foreground
 * dark enough to stay legible on it. Cycled by index across card lists.
 */
export interface IconTone {
  bg: string
  fg: string
}

export const iconTones: IconTone[] = [
  { bg: 'bg-[#DAE5F5]', fg: 'text-[#1E3E66]' },
  { bg: 'bg-[#D2E6F7]', fg: 'text-[#0A5893]' },
  { bg: 'bg-[#D1E7E6]', fg: 'text-[#14615E]' },
  { bg: 'bg-[#DBE0F3]', fg: 'text-[#37418F]' },
  { bg: 'bg-[#D5E5EE]', fg: 'text-[#185B72]' },
  { bg: 'bg-[#DCE4EC]', fg: 'text-[#34506B]' },
]

export function toneAt(index: number): IconTone {
  return iconTones[index % iconTones.length]
}
